import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { mockSupplies } from '../../data/mockData';

export default function SuppliesView() {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-6 pb-20 md:pb-6 max-w-3xl mx-auto"
    >
      <div>
        <h2 className="text-2xl font-bold text-clay">Inventory Array</h2>
        <p className="text-sm text-clay-muted">Resource tracking and procurement alerts.</p>
      </div>

      <div className="glass-panel rounded-xl overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-garden-dark border-b border-garden-base">
              <th className="p-4 text-xs font-mono text-clay-dark uppercase">Resource Name</th>
              <th className="p-4 text-xs font-mono text-clay-dark uppercase">Quantity</th>
              <th className="p-4 text-xs font-mono text-clay-dark uppercase">Status</th>
              <th className="p-4 text-xs font-mono text-clay-dark uppercase text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {mockSupplies.map((supply, i) => (
              <tr key={supply.id} className="border-b border-garden-base/50 hover:bg-garden-base/20 transition-colors">
                <td className="p-4 text-sm text-clay font-medium">{supply.name}</td>
                <td className="p-4 text-sm font-mono text-clay-muted">{supply.amount}</td>
                <td className="p-4">
                  <span className={`inline-flex items-center px-2 py-1 rounded text-[10px] font-mono uppercase ${
                    supply.status === 'Empty' ? 'bg-red-400/10 text-red-400 border border-red-400/20' : 
                    supply.status === 'Low' ? 'bg-yellow-400/10 text-yellow-400 border border-yellow-400/20' :
                    'bg-lime/10 text-lime border border-lime/20'
                  }`}>
                    {supply.status}
                  </span>
                </td>
                <td className="p-4 text-right">
                  <button className="p-2 text-clay-dark hover:text-lime transition-colors">
                    <SafeIcon icon="ShoppingCart" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="bg-garden-dark p-6 rounded-xl border border-garden-base flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-garden-base flex items-center justify-center">
            <SafeIcon icon="Book" className="text-clay-muted" />
          </div>
          <div>
            <h4 className="text-sm font-medium text-clay">Need guidance?</h4>
            <p className="text-xs text-clay-muted">Access the beginner botanical protocols.</p>
          </div>
        </div>
        <button className="px-4 py-2 border border-garden-base rounded-lg text-sm text-clay hover:bg-garden-base transition-colors">
          Open Guide
        </button>
      </div>
    </motion.div>
  );
}